var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeLoadingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3521 40.3756L58.8013 55.4844C58.8868 55.6849 58.8997 55.9126 58.7823 56.0962C58.7246 56.1864 58.648 56.2888 58.5486 56.3913C58.286 56.6621 57.8615 56.5917 57.5839 56.3363L45.8584 45.5471L50.8539 40.1181C51.2987 39.6346 52.0942 39.7713 52.3521 40.3756Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 0.0904981
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4682 54.8432L39.019 39.7343C38.9335 39.5339 38.9206 39.3062 39.038 39.1226C39.0957 39.0323 39.1723 38.93 39.2717 38.8275C39.5343 38.5567 39.9588 38.6271 40.2364 38.8825L51.9619 49.6716L46.9665 55.1007C46.5216 55.5841 45.7261 55.4474 45.4682 54.8432Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 0.0904981
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.7891,
    width: 31.4364,
    height: 52.1384,
    rx: 5.36719,
    transform: "rotate(41.8544 34.7891 0)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1953,
    y: 35.3008,
    width: 31.4364,
    height: 52.1384,
    rx: 5.36719,
    transform: "rotate(41.8544 74.1953 35.3008)",
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLoadingLogo);
export default __webpack_public_path__ + "static/media/home-loading-logo.614367d832a58c3385a81c9e00853dbb.svg";
export { ForwardRef as ReactComponent };